import { useId, useState } from 'react';

// Segmented-control tabs. Replaces the theme's jQuery `.gtco-tabs`.
// `items` is [{ id, label, render }].
const Tabs = ({ items, label = 'Sections' }) => {
  const [active, setActive] = useState(items[0]?.id);
  const uid = useId();

  return (
    <>
      <div className="segmented" role="tablist" aria-label={label}>
        {items.map(({ id, label: tabLabel }) => (
          <button
            key={id}
            type="button"
            role="tab"
            id={`${uid}-tab-${id}`}
            aria-selected={active === id}
            aria-controls={`${uid}-panel-${id}`}
            onClick={() => setActive(id)}
          >
            {tabLabel}
          </button>
        ))}
      </div>

      {items.map(({ id, render }) => (
        <div
          key={id}
          className="tabpanel"
          role="tabpanel"
          id={`${uid}-panel-${id}`}
          aria-labelledby={`${uid}-tab-${id}`}
          hidden={active !== id}
          tabIndex={-1}
        >
          {active === id && render()}
        </div>
      ))}
    </>
  );
};

export default Tabs;
